/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * DailyTaskAcfBase
 * auto generated base class for the model DailyTaskAcfModel.
 */
export const DailyTaskAcfModelBase = ModelBase.named('DailyTaskAcf')
  .props({
    __typename: types.optional(types.literal('DailyTaskACF'), 'DailyTaskACF'),
    daily_task: types.union(types.undefined, types.string),
    daily_task_category: types.union(types.undefined, types.string),
    daily_task_deeplink_url: types.union(types.undefined, types.string),
    daily_task_icon: types.union(types.undefined, types.string),
    daily_task_subheader: types.union(types.undefined, types.string),
    daily_task_video_url: types.union(types.undefined, types.string),
    day: types.union(types.undefined, types.string),
    order_value: types.union(types.undefined, types.string),
    week: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DailyTaskAcfModelSelector extends QueryBuilder {
  get daily_task() {
    return this.__attr('daily_task')
  }
  get daily_task_category() {
    return this.__attr('daily_task_category')
  }
  get daily_task_deeplink_url() {
    return this.__attr('daily_task_deeplink_url')
  }
  get daily_task_icon() {
    return this.__attr('daily_task_icon')
  }
  get daily_task_subheader() {
    return this.__attr('daily_task_subheader')
  }
  get daily_task_video_url() {
    return this.__attr('daily_task_video_url')
  }
  get day() {
    return this.__attr('day')
  }
  get order_value() {
    return this.__attr('order_value')
  }
  get week() {
    return this.__attr('week')
  }
}
export function selectFromDailyTaskAcf() {
  return new DailyTaskAcfModelSelector()
}

export const dailyTaskAcfModelPrimitives =
  selectFromDailyTaskAcf().daily_task.daily_task_category.daily_task_deeplink_url.daily_task_icon.daily_task_subheader
    .daily_task_video_url.day.order_value.week
